import './StatusMessage.css';

import React, { useState } from 'react'
import { Message } from 'semantic-ui-react'


const StatusMessage = ({ content, msgType }) => {

    const [visible, setVisible] = useState(true);

    const handleDismiss = () => {
        setVisible(false);
    }

    if (visible) {
        return (
            <Message 
                success={msgType==='success'}
                error={msgType==='error'}
                info={msgType==='info'}
                warning={msgType==='warning'}
                onDismiss={handleDismiss}
                header='VanuMaps'
                content={content}
            />
        )
    }

    return (
        <div></div>
    )

}

export default StatusMessage
